import { FFFStorage } from '@nexus/fff-utilities';
import { UNAVAILABLE, NOT_SUBSCRIBED } from '../../components/MyBox/boxStatusId';
import { getLocalStorage } from '../../utils/localStorageHelpers';

export const getInitialValueFromStorage = (key, defaultValue) => {
  const data = FFFStorage.getFromStorage(key);

  if (data && data.data) {
    return { data: data.data, loading: false, fail: false };
  }

  return { data: defaultValue, loading: false, fail: false };
};

export const setInitialValueToStorage = (key, value) => FFFStorage.setToStorage(key, { data: value });

export const isUnavailableStatus = (status) => status && status.id === UNAVAILABLE;

export const isNotSubscribedStatus = (status) => status && status.id === NOT_SUBSCRIBED;

export const isExpired = (data) => (
  !data.fail && Object.keys(data.data).length > 0 && data.data.status && data.data.status.id === 'EXPIRED'
);

export const isHomepageLoading = ({
  heroBanner, myBox, webCards, seasonalTimelines,
}) => (
  heroBanner.loading || myBox.loading || webCards.loading || seasonalTimelines.loading
);

export const getInvitePopupExpirationFromStorage = (key) => {
  let invitePopupExpDate = getLocalStorage(key);
  if (invitePopupExpDate === null) {
    invitePopupExpDate = 0;
  }
  return Date.parse(invitePopupExpDate);
};
